import { render, staticRenderFns } from "./preview-pdf.vue?vue&type=template&id=2b4b3e20&scoped=true&"
import script from "./preview-pdf.vue?vue&type=script&lang=js&"
export * from "./preview-pdf.vue?vue&type=script&lang=js&"
import style0 from "./preview-pdf.vue?vue&type=style&index=0&id=2b4b3e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b3e20",
  null
  
)

export default component.exports